import { observer } from "mobx-react-lite";
import { MdsVirtualizedItemList } from "@/design-system/components/item-list";
import { NotesListPageListEmpty } from "./NotesListPageListEmpty";
import { useTabPageStore } from "@/hooks/useTabPageStore";

interface Props {
  isDragging?: boolean;
}

export const HomePageNotesList = observer<Props>(() => {
  const page = useTabPageStore("notesListPage");
  const { filters } = page;

  if (page.hasNoItems) {
    return <NotesListPageListEmpty />;
  }

  return (
    <>
      {!page.isLoading && (
        <MdsVirtualizedItemList
          rows={page.itemRows}
          listState={page.listState}
          endReached={filters.increaseLimit}
          scrollTop={page.scrollTop}
          setScrollTop={page.setScrollTop}
        />
      )}
      {page.listState.multiSelectUi}
    </>
  );
});
